exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mt-3[data-v-2e0ecd09]{margin-top:1rem}.ml-1[data-v-2e0ecd09]{margin-left:.25rem}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2e0ecd09","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/ims/BlockAccountsClient.vue
// module id = 194
// module chunks = 0